import { render, staticRenderFns } from "./webForm.vue?vue&type=template&id=2b313019&scoped=true&"
import script from "./webForm.vue?vue&type=script&lang=js&"
export * from "./webForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b313019",
  null
  
)

export default component.exports